export const buildDailyExcelRows = (filteredStudents = [], dailyAttendance = {}) => (
  filteredStudents.map((student) => ({
    이름: student.name,
    학년: student.grade,
    반: student.class || "",
    상태:
      dailyAttendance[student.id] === "present"
        ? "출석"
        : dailyAttendance[student.id] === "late"
          ? "지각"
          : dailyAttendance[student.id] === "absent"
            ? "결석"
            : "미처리",
    비고: student.notes || "",
  }))
);

export const writeDailyExcelFile = ({ XLSX, rows, currentDate }) => {
  const ws = XLSX.utils.json_to_sheet(rows);
  ws["!cols"] = [
    { wch: 10 },
    { wch: 6 },
    { wch: 6 },
    { wch: 8 },
    { wch: 30 },
  ];
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "일별출석");
  XLSX.writeFile(wb, `출석부_${currentDate}.xlsx`);
};

export const buildMonthlyExcelPayload = ({
  filteredStudents = [],
  monthlyData = {},
  sundaysInMonth = [],
  getMonthlyAttendanceRateFn,
}) => {
  const header = ["이름", ...sundaysInMonth, "출석률(%)"];

  const rows = filteredStudents.map((student) => {
    const row = [student.name];
    sundaysInMonth.forEach((date) => {
      const status = monthlyData[date]?.[student.id];
      row.push(status === "present" ? "O" : status === "late" ? "△" : status === "absent" ? "X" : "-");
    });
    const rate = getMonthlyAttendanceRateFn(student.id, sundaysInMonth, monthlyData);
    row.push(`${rate}%`);
    return row;
  });

  return { header, rows };
};

export const writeMonthlyExcelFile = ({ XLSX, header, rows, sundaysInMonth, currentMonth }) => {
  const ws = XLSX.utils.aoa_to_sheet([header, ...rows]);
  const cols = [{ wch: 10 }];
  sundaysInMonth.forEach(() => cols.push({ wch: 12 }));
  cols.push({ wch: 10 });
  ws["!cols"] = cols;

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "월간출석");
  XLSX.writeFile(wb, `월간출석부_${currentMonth}.xlsx`);
};

export const buildAttendanceShareText = ({ currentDate, dailyStats, filteredCount }) => (
  `[📅 ${currentDate} 출석 현황]\n✅ 출석: ${dailyStats.present}명\n⚠️ 지각: ${dailyStats.late}명\n🚨 결석: ${dailyStats.absent}명\n☁️ 미처리: ${dailyStats.none}명\n----------------\n총원: ${filteredCount}명`
);

export const buildViewingStudentShareText = ({ viewingStudent }) => (
  `[학생 정보]\n이름: ${viewingStudent.name}\n연락처: ${viewingStudent.phone}`
);
